module.exports = __webpack_public_path__ + "img/r-28.a26237ba.jpg";